import { Component, AfterViewInit, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls : ['./blog.component.css']
})
export class BlogComponent {

  constructor(public shared: SharedService){
    this.shared.isWhiteMenu = false;
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() : void{
    this.shared.includeMainScript();
  }
}